<div class="row">
    <div class="col-md-12 col-lg-9">
        <div class="card">
            <div class="card-body">
                <spinner [showSpinner]="isLoading">
                    <div class="table-container">
                        <div class="table-responsive">
                            <table class="table table-hover ">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Id</th>
                                        <th>Name</th>
                                        <th>Created</th>
                                        <th>Claims</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let resource of resources">
                                        <td>
                                            <i class="mdi mdi-record mdi-18px"
                                                [ngClass]="resource.enabled ? 'notice-green' : 'notice-red' "></i>
                                        </td>
                                        <td>
                                            {{resource.id}}
                                        </td>
                                        <td>
                                            {{resource.name}}
                                        </td>
                                        <td>
                                            {{resource.createdAt | date:'yyyy-MM-dd HH:mm:ss'}}
                                        </td>
                                        <td>
                                            {{ resource.userClaims.join(' ') }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </spinner>
            </div>
        </div>
    </div>
</div>